import React from 'react';
import { View, Image } from 'react-native';

import styles from '../styles';
import { AppText } from '../../../components/form';
import splash_02 from '../../../assets/images/splash_02.jpg';
import logo_purple from '../../../assets/images/logo_purple.png';

const WelcomeTwo = ({ navigation }) => {
  const navigateTo = (site) => navigation.navigate(`Welcome ${site}`);
  return (
    <View style={styles.viewBase} onTouchEnd={() => navigateTo('Three')}>
      <View style={styles.viewLogo}>
        <Image style={styles.imageLogo} source={logo_purple} />
      </View>
      <View style={styles.lineBlue}>
        <View style={styles.lineCyan}>
          <Image style={styles.imageSplash} source={splash_02} />
        </View>
      </View>
      <View style={styles.card}>
        <AppText style={[styles.textWelcome, styles.textSmaller]}>{'AUMENTE SUA\nPRODUTIVIDADE\nEXERCITE-SE!'}</AppText>
        <View style={styles.viewBallContainer}>
          <View style={[styles.viewBall]} />
          <View style={[styles.viewBall, styles.viewBallOrange]} />
          <View style={styles.viewBall} />
        </View>
      </View>
    </View>
  );
};

export default WelcomeTwo;
